import { ArrowBackIosNewOutlined, ArrowForwardIosOutlined } from "@mui/icons-material";
import { Pagination, TablePagination, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";

const PaginateButton = styled("button")({
  backgroundColor: "transparent",
  padding: "4px",
  fontSize: "16px",
  lineHeight: "20px",
  width: "32px",
  height: "32px",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
});

function TablePaginationActions({
  count: totalElements,
  rowsPerPage,
  onPageChange,
  page: curPage,
}) {
  const pageCount = Math.ceil(totalElements / rowsPerPage);
  const onPaginationChange = (e, selectedPage) => {
    onPageChange(e, selectedPage - 1);
  };
  return (
    <Pagination
      count={pageCount}
      onChange={onPaginationChange}
      sx={({ breakpoints }) => ({
        flex: 1,
        display: "flex",
        justifyContent: "flex-end",
        [breakpoints.down("sm")]: {
          justifyContent: "center",
        },

        "& .MuiPagination-ul": {
          gap: "6px",
          flexWrap: "nowrap",
        },
      })}
      renderItem={(props) => {
        // eslint-disable-next-line react/prop-types
        const { page, type } = props;
        let children = null;
        if (type === "start-ellipsis" || type === "end-ellipsis") {
          children = "…";
        } else if (type === "page") {
          children = (
            <PaginateButton
              type="button"
              style={{
                fontWeight: page - 1 === curPage ? "bold" : undefined,
                border:
                  page - 1 === curPage ? "0.0625rem solid #0094FF" : "0.0625rem solid #E1E3E9",
                borderRadius: "0.5rem",
                color: page - 1 === curPage ? "var(--blue-blue-100)" : "#3F4254",
              }}
              {...props}
            >
              {page}
            </PaginateButton>
          );
        } else if (type === "previous") {
          children = (
            <Tooltip title="Về Trước" placement="top">
              <span>
                <PaginateButton
                  style={{ border: "0.0625rem solid #E1E3E9", borderRadius: "0.5rem" }}
                  type="button"
                  disabled={page === 0}
                  {...props}
                >
                  <ArrowBackIosNewOutlined />
                </PaginateButton>
              </span>
            </Tooltip>
          );
        } else if (type === "next") {
          children = (
            <Tooltip title="Về sau" placement="top">
              <span>
                <PaginateButton
                  style={{ border: "0.0625rem solid #E1E3E9", borderRadius: "0.5rem" }}
                  type="button"
                  disabled={page >= Math.ceil(totalElements / rowsPerPage) - 1}
                  {...props}
                >
                  <ArrowForwardIosOutlined />
                </PaginateButton>
              </span>
            </Tooltip>
          );
        }
        return children;
      }}
    />
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  curPage: PropTypes.number,
};

TablePaginationActions.defaultProps = {
  curPage: 0,
};

function LabelDisplayedRows(totalElements) {
  return (
    <span style={{ display: "flex", fontSize: "16px", fontWeight: "400" }}>
      /Page trong tổng số <b style={{ marginLeft: 4 }}>{totalElements}</b>
    </span>
  );
}

function TablePaginationCustom({
  totalElements,
  page,
  rowsPerPage,
  setPage,
  setRowsPerPage,
  rowsPerPageOptions,
}) {
  const onRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  return (
    <TablePagination
      sx={({ breakpoints }) => ({
        display: "flex",
        justifyContent: "center",
        boxShadow: "none",
        border: "none",
        padding: 0,
        // marginTop: "24px",
        background: "transparent",
        ".MuiInputBase-root": {
          width: "auto !important",
          [breakpoints.down("sm")]: {
            margin: 0,
          },
        },
        ".MuiTablePagination-spacer": {
          flex: 0,
        },
        ".MuiTablePagination-selectLabel": {
          display: "none",
        },
        ".MuiPagination-root": {
          order: -1,
        },
        ".MuiToolbar-root": {
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          "> .MuiInputBase-root": {
            margin: "0 8px",
            padding: "5px 12px",
            ".MuiTablePagination-select": {
              fontWeight: "600",
              textAlignLast: "center",
            },
          },
        },
        [breakpoints.down("sm")]: {
          "& .MuiToolbar-root": {
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "12px",
          },
        },
        "@media (max-width: 500px)": {
          bottom: "-80px !important",
        },
      })}
      labelDisplayedRows={() => LabelDisplayedRows(totalElements)}
      rowsPerPageOptions={rowsPerPageOptions}
      rowsPerPage={rowsPerPage}
      component="div"
      count={totalElements}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={onRowsPerPageChange}
      ActionsComponent={TablePaginationActions}
    />
  );
}
export default TablePaginationCustom;

TablePaginationCustom.defaultProps = {
  rowsPerPage: 5,
  page: 0,
  setPage: () => {},
  setRowsPerPage: () => {},
  rowsPerPageOptions: [20, 50, 100, 200],
};

TablePaginationCustom.propTypes = {
  totalElements: PropTypes.number.isRequired,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  setPage: PropTypes.func,
  setRowsPerPage: PropTypes.func,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
};
